import { pluck, filter, map, mergeMap } from 'rxjs/operators'
import { ofType, combineEpics, ActionsObservable, StateObservable } from 'redux-observable'
import { roomTypes } from '../../../actions/room/roomTypes'
import { ReduxAction, State } from '../../../reducers/reducerType'
import { ParticipantInformationInterface } from '../../../reducers/docs/syncUi/types'
import setParticipantInformation from 'apps/talks-present/src/app/lib/setParticipantInformation'
import { from } from 'rxjs'

export const addMissingParticipantInformation$ = (action$: ActionsObservable<ReduxAction>, state$: StateObservable<State>) => action$.pipe(
  ofType(roomTypes.SET_MISSING_PARTICIPANT_INFORMATION),
  pluck<ReduxAction, ParticipantInformationInterface>('payload'),
  filter((participant) => !state$.value.syncUi.participantInformation.some(item => participant.BTID === item.BTID)),
  mergeMap((participant) =>
    from(setParticipantInformation(state$.value.docs.uiDoc, participant)).pipe(
      map(() => ({
        type: roomTypes.MISSING_PARTICIPANT_ADDED
      }))
    )
  )
)

export default combineEpics(addMissingParticipantInformation$)
